import { LoadingPriorisationFormModel, LoadingPriorisationModel } from 'src/Libs/wallboxes/models'

const loadPrioModelToFormTransformer = (model: LoadingPriorisationModel): LoadingPriorisationFormModel => ({
  isBattery: model.isBattery,
  inMixMode: model.inMixMode,
  inSunMode: model.inSunMode,
  tillSoc: model.tillSoc || '',
})

export default loadPrioModelToFormTransformer
